/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum SystemManagerExportReturnCodes {
  Success = 0,
  NotSysQueSystem = 1,
  ImportSuccess = 2,
  InvalidFileSelection = 3,
  FailImport = 4
}
